/**
 * Move impulses from seperate store into simulation round
 */

export default {
  applyToVersions: "<2.2.0",
  type: "before",
  name: "startElementId -> startItemId",
  migrate(data) {
    if (data?.elementResources?.items) {
      for (const elementResourceId in data.elementResources.items) {
        const elementResource = data.elementResources.items[elementResourceId];

        if (elementResource.elementId != null) {
          elementResource.startItemId = elementResource.elementId;
          elementResource.startItemType = "element";
          delete elementResource.elementId;
        }
        if (elementResource.resourceId != null) {
          elementResource.endItemId = elementResource.resourceId;
          elementResource.endItemType = "resource";
          delete elementResource.resourceId;
        }
      }
    }

    if (data?.relations?.items) {
      for (const relationId in data.relations.items) {
        const relation = data.relations.items[relationId];

        if (relation.startElementId != null) {
          relation.startItemId = relation.startElementId;
          relation.startItemType = "element";
          delete relation.startElementId;
        }
        if (relation.endElementId != null) {
          relation.endItemId = relation.endElementId;
          relation.endItemType = "element";
          delete relation.endElementId;
        }

        if (relation.curveType != null) {
          relation.changeCurveType = relation.curveType;
          delete relation.curveType;
        }

        if (relation.constantCurvePoints == null) {
          relation.constantCurvePoints = [
            {
              id: 0,
              x: 0,
              y: 0,
              bezierOut: {
                x: 0,
                y: 0
              }
            },
            {
              id: 1,
              x: 100,
              y: 0,
              bezierIn: {
                x: 0,
                y: 0
              }
            }
          ];
        }
      }
    }

    return data;
  }
};
